import {registerExpressPaymentMethod} from '@woocommerce/blocks-registry';
import {getSettings, initStripe as loadStripe, isCartPage, isCheckoutPage} from '../util';
import {useErrorMessage} from "./hooks";
import GooglePayButton from './button';
import {BASE_PAYMENT_METHOD, BASE_PAYMENT_REQUEST} from './constants';
import google from '@googlepay';
import {Elements} from "@stripe/react-stripe-js";
import {GooglePayPreview} from "./preview";

const getData = getSettings('stripe_googlepay_data');

const canMakePayment = (() => {
    const paymentsClient = new google.payments.api.PaymentsClient({
        environment: getData('environment'),
        merchantInfo: {
            merchantId: getData('merchantId'),
            merchantName: getData('merchantName')
        }
    });
    const isReadyToPayRequest = {...BASE_PAYMENT_REQUEST, allowedPaymentMethods: [BASE_PAYMENT_METHOD]};
    return paymentsClient.isReadyToPay(isReadyToPayRequest).then(() => {
        return true;
    }).catch(err => {
        console.log(err);
        return false;
    })
})();

const GooglePayContent = ({getData, components, ...props}) => {
    const {ValidationInputError} = components;
    const {errorMessage, setErrorMessage} = useErrorMessage();
    return (
        <div className='wc-stripe-gpay-container'>
            <Elements stripe={loadStripe}>
                <GooglePayButton
                    getData={getData}
                    canMakePayment={canMakePayment}
                    setErrorMessage={setErrorMessage}
                    {...props}/>
                {errorMessage && <ValidationInputError errorMessage={errorMessage}/>}
            </Elements>
        </div>
    )
}

registerExpressPaymentMethod({
    name: getData('name'),
    canMakePayment: () => {
        if (isCartPage() && !getData('cartCheckoutEnabled')) {
            return false;
        }
        if (isCheckoutPage() && !getData('expressCheckoutEnabled')) {
            return false;
        }
        return loadStripe.then(stripe => {
            if (stripe.error) {
                return stripe;
            }
            return canMakePayment;
        });
    },
    content: <GooglePayContent getData={getData}/>,
    edit: <GooglePayPreview getData={getData}/>,
    supports: {
        showSavedCards: getData('showSavedCards'),
        showSaveOption: getData('showSaveOption'),
        features: getData('features')
    }
});